import React from 'react'

function TextLanguage({language,dk,en}) {
  return (
    <>{language === 'en' ? en : dk}</>
  )
}

export default TextLanguage